import { segmentForDate } from 'src/utils/rollup';
import normalizeDate from 'src/utils/normalizeDate';

export default function pointsOfInterest({
  currentSegment,
  retirementSegment,
  liabilities,
  segments,
  rollup,
}) {
  const annotations = [];

  // add today indicator
  if (currentSegment)
    annotations.push({
      type: 'line',
      borderColor: 'gray',
      borderWidth: 1,
      borderDash: [6, 6],
      display: (ctx) => ctx.chart.isDatasetVisible(1),
      label: {
        display: true,
        content: 'Now',
        position: 'start',
      },
      scaleID: 'x',
      value: currentSegment.label,
    });

  // add retirement date
  if (retirementSegment)
    annotations.push({
      type: 'line',
      borderColor: 'gray',
      borderWidth: 1,
      borderDash: [6, 6],
      display: (ctx) => ctx.chart.isDatasetVisible(1),
      label: {
        display: true,
        content: 'Retirement',
        position: 'start',
      },
      scaleID: 'x',
      value: retirementSegment?.label,
    });

  // Add liability payoff dates
  if (liabilities?.allLiabilities)
    liabilities?.allLiabilities.forEach(({ name, loan_name, account, expected_payoff_date }) => {
      if (expected_payoff_date) {
        const dates = segments.map((e) => e.value);
        const segment = segmentForDate(rollup, normalizeDate(expected_payoff_date), dates);
        const label = name ?? account?.official_name ?? account?.name ?? loan_name;

        if (segment !== -1) {
          annotations.push({
            type: 'line',
            borderColor: 'gray',
            borderWidth: 1,
            borderDash: [6, 6],
            display: (ctx) => ctx.chart.isDatasetVisible(1),
            label: {
              display: true,
              content: `${label} payoff`,
              position: 'start',
            },
            scaleID: 'x',
            value: segment,
          });
        }
      } else {
        console.log('no expected payoff date', name, loan_name, account);
      }
    });

  return annotations;
}
